import api from './ajax.js';

document.addEventListener("DOMContentLoaded", function () {
	const selectClient = document.getElementById("selectClient");

	if (!selectClient) return;

	// Get the jobId from data attr on the select element
	const jobId = selectClient.dataset.spJobId;

	// Get the initial value of the select element
	const initialClientId = selectClient.value;

	if (initialClientId) {
		getAndSetClient(jobId, initialClientId);
	}

	selectClient.addEventListener("change", function () {
		const clientId = this.value;

		// If no client is selected, clear the fields and return
		if (!clientId) {
			clearFields();
			return;
		}

		getAndSetClient(jobId, clientId);
	});

	function getAndSetClient(jobId, clientId) {
		api.addClientToJob(jobId, clientId).then(response => {
			if (response.error) {
				alert('An error occurred');
			} else {
				const data = response.body;
				const client = data.client;
				const address = client.address;
				const shedType = client.shed_type;
				// Populate fields with the data
				document.getElementById("clientCompanyTradingName").value = client.company_trading_name || "";
				document.getElementById("clientCompanyABN").value = client.abn || "";
				document.getElementById("firstName").value = client.first_name || "";
				document.getElementById("clientLastName").value = client.last_name || "";
				document.getElementById("clientEmail").value = client.email || "";
				document.getElementById("clientPhone").value = client.phone || "";
				document.getElementById("clientAddress").value = address.address_line_1 || "";
				document.getElementById("clientCity").value = address.city || "";
				document.getElementById("clientState").value = address.state || "";
				document.getElementById("clientPostcode").value = address.postcode || "";

				console.log(shedType);

				if (shedType && shedType === 'STANDARD') {
					document.getElementById('clientStandardShed').checked = true;
					document.getElementById('clientStayOutShed').checked = false;
					//
					// $('#clientStandardShed').prop("checked", true);
					// $('#clientStayOutShed').prop("checked", false);
					//
					// console.log($('#clientStandardShed'));
				}

				if (shedType && shedType === 'STAY_OUT') {
					document.getElementById('clientStandardShed').checked = false;
					document.getElementById('clientStayOutShed').checked = true;

					// $('#clientStandardShed').prop("checked", false);
					// $('#clientStayOutShed').prop("checked", true);
				}

			}
		});
	}

	// Helper function to clear all fields
	function clearFields() {
		const fields = [
			"clientCompanyTradingName",
			"clientCompanyABN",
			"firstName",
			"clientLastName",
			"clientEmail",
			"clientPhone",
			"clientAddress",
			"clientCity",
			"clientState",
			"clientPostcode",
		];
		fields.forEach((fieldId) => {
			const field = document.getElementById(fieldId);
			if (field) field.value = "";
		});

		const referenceImageLink = document.querySelector("#clientRefImg a");
		if (referenceImageLink) {
			referenceImageLink.removeAttribute("data-sp-image");
			referenceImageLink.innerHTML = "";
		}
	}
});
